import { Linking, Platform } from 'react-native'

export const handleLink = async (link: string) => {
    if (Platform.OS === 'web') {
        window.open(link, '_blank')
    } else {
        await Linking.openURL(link)
    }
}
